export type ApiCatalogEmptyStateVariant = 'none' | 'catalog-empty' | 'no-results';

export function getApiCatalogEmptyStateVariant({
  hasItems,
  isLoading,
  searchValue,
  hasActiveFilters,
}: {
  hasItems: boolean;
  isLoading: boolean;
  searchValue: string;
  hasActiveFilters: boolean;
}): ApiCatalogEmptyStateVariant {
  if (isLoading || hasItems) return 'none';
  if (searchValue.trim().length > 0 || hasActiveFilters) return 'no-results';
  return 'catalog-empty';
}
